<template>
  <div class="boxDiv">
    <el-form label-width="139px" class="elform" style="margin-top:30px" :model="form">
      <el-form-item :rules="[{ required: true}]" prop label="企业全称：" style="display:flex">
        <el-input v-model="Name" placeholder="请输入企业全称" maxlength="50"/>
      </el-form-item>
      <el-form-item :rules="[ { required: true} ]" prop style="display:flex" label="联系人：">
        <el-input v-model="Contacts" placeholder="请输入联系人" maxlength="20"/>
      </el-form-item>
      <el-form-item :rules="[{ required: true}]" prop label="联系电话：" style="display:flex">
        <el-input  @blur="isblur" v-model="CPhone" placeholder="请输入联系电话" maxlength="11"
        onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"/>
      </el-form-item>
      <el-form-item style="display:flex" label="统一社会应用代码：">
        <el-input v-model="UsaCode" placeholder="请输入统一社会应用代码" maxlength="50"/>
      </el-form-item>
      <el-form-item style="display:flex" label="法定代表人：">
        <el-input v-model="Boss" placeholder="请输入法定代表人" maxlength="20"/>
      </el-form-item>
      <el-form-item style="display:flex" label="注册资本：">
        <el-input  @blur="isblur" v-model="RCapital"  placeholder="请输入注册资本" maxlength="8"
        onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')"/>
      </el-form-item>
      <el-form-item :rules="[{ required: true}]" prop label="经营范围：" style="display:flex">
        <el-input v-model="Scope" placeholder="请输入经营范围" maxlength="50"/>
      </el-form-item>
      <el-form-item :rules="[{ required: true}]" prop label="企业规模：" style="display:flex">
        <el-select style="width:100%" v-model="EScale" placeholder="请选择">
          <el-option v-for="item in stautIdarr" :key="item.Id" :label="item.Name" :value="item.Id"/>
        </el-select>
      </el-form-item>
      <el-form-item :rules="[{ required: true}]" prop label="注册地址：" style="display:flex">
        <el-input v-model="RAddress" placeholder="请输入注册地址" maxlength="100"/>
      </el-form-item>
      <el-form-item :rules="[{ required: true}]" prop label="公司介绍：" style="display:flex">
        <el-input type="textarea" v-model="Introduction" :autosize="{ minRows: 2, maxRows: 6}"
        maxlength="1000" placeholder="请输入公司介绍"/>
      </el-form-item>
    </el-form>
    <div style="margin-left:28%;margin-top:30px">
      <el-button type="danger" @click="emit()">保存</el-button>
      <el-button type="danger" @click="goback()">返回</el-button>
    </div>
  </div>
</template>
<script>
import { InsertDCExtendInfo, getkind, SelectDCDetailById, UpdateDCExtendInfo, } from "../../api/api";
export default {
  name: "extend1",
  props: ["isadd"],
  data() {
    return {
      form: {},
      Name: "",
      Contacts: "",
      CPhone: "",
      UsaCode: "",
      Boss: "",
      RCapital: "",
      Scope: "",
      EScale: "",
      stautIdarr: [],
      RAddress: "",
      Introduction: ""
    };
  },
  methods: {
    isblur(){
      this.CPhone = this.CPhone.replace(/[^\d\.]/g,'').replace('.','');
      this.RCapital = this.RCapital.replace(/[^\d\.]/g,'').replace('.','');
    },
    init(val) {
      if(val == 8) {
        this.getInfoById();
      }
    },
    getInfoById() {
      var obj = {
        userId: localStorage.Id,
        dcId: localStorage.businessBbId,
        operTypeId: 1
      };
      SelectDCDetailById(obj).then(data => {
        if (data.ResultCode == 1) {
          this.Name = data.ResultObj.Name;
          this.Contacts = data.ResultObj.Contacts;
          this.CPhone = data.ResultObj.CPhone;
          this.UsaCode = data.ResultObj.UsaCode;
          this.Boss = data.ResultObj.Boss;
          this.RCapital = data.ResultObj.RCapital;
          this.Scope = data.ResultObj.Scope;
          this.EScale = data.ResultObj.EScale;
          this.RAddress = data.ResultObj.RAddress;
          this.Introduction = data.ResultObj.Introduction;
        }
      });
    },
    goback() {
      this.$router.go(-1);
      // if(this.$route.query.type == 1){
      //   this.$router.push({
      //       path:"/companyList"
      //   })
      // }else{
      //   this.$router.push({
      //       path:"/companyList",
      //       query:{
      //         type:2,
      //         pageIndex : this.$route.query.pageIndex,
      //         name:this.$route.query.name,
      //         provinceId:this.$route.query.provinceId,
      //         cityId :this.$route.query.cityId,
      //         statusId:this.$route.query.statusId,
      //         isfind:this.$route.query.isfind
      //       }
      //   })
      // }
    },
    emit() {
      if (this.Name == "") {
        this.$swal({
          type: "warning",
          text: "请输入企业全称"
        });
        return false;
      } else if (this.Contacts == "") {
        this.$swal({
          type: "warning",
          text: "请输入联系人"
        });
        return false;
      }  else if (this.CPhone == "") {
        this.$swal({
          type: "warning",
          text: "请输入联系电话"
        });
        return false;
      } else if(/^1[3456789]\d{9}$/.test(this.CPhone) == false){
        this.$swal({
          type:"warning",
          text:"请输入正确的联系电话"
        })
        return false;
      }else if (this.Scope == "") {
        this.$swal({
          type: "warning",
          text: "请输入经营范围"
        });
        return false;
      } else if (this.EScale == 0) {
        this.$swal({
          type: "warning",
          text: "请选择企业规模"
        });
        return false;
      } else if (this.RAddress == "") {
        this.$swal({
          type: "warning",
          text: "请输入注册地址"
        });
        return false;
      } else if (this.Introduction == "") {
        this.$swal({
          type: "warning",
          text: "请输入公司介绍"
        });
        return false;
      }
      if (this.isadd) {
        var obj = {
          Name: this.Name,
          Contacts: this.Contacts,
          CPhone: this.CPhone,
          UsaCode: this.UsaCode,
          Boss: this.Boss,
          RCapital: this.RCapital,
          Scope: this.Scope,
          EScale: this.EScale,
          RAddress: this.RAddress,
          Introduction: this.Introduction,
          COperator: localStorage.Id
        };
        InsertDCExtendInfo(obj).then(data => {
          if (data.ResultCode == 1) {
            console.log(data);
            this.$emit("isaddfun", false);
            localStorage.companyId = data.ResultObj;
            this.$swal({
              type: "success",
              text: "保存成功"
            });
          }
          // this.$emit("changespanshow",1)
        });
      } else {
        var obj = {
          // DcId: localStorage.companyId,
          DcId: localStorage.businessBbId,
          Name: this.Name,
          Contacts: this.Contacts,
          CPhone: this.CPhone,
          UsaCode: this.UsaCode,
          Boss: this.Boss,
          RCapital: this.RCapital,
          Scope: this.Scope,
          EScale: this.EScale,
          RAddress: this.RAddress,
          Introduction: this.Introduction,
          COperator: localStorage.Id
        };
        UpdateDCExtendInfo(obj).then(data => {
          if (data.ResultCode == 1) {
            console.log(data);
            this.$emit("isaddfun", false);
            // localStorage.companyId = data.ResultObj
            this.$swal({
              type: "success",
              text: "保存成功"
            });
            // this.$emit("changespanshow",3)
          }
        });
      }
    },
    //查询状态
    getstatus() {
      var loginParams = {
        tableName: "tBDEScale",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        this.stautIdarr = data.ResultObj;
        this.stautIdarr.unshift({
          Id: 0,
          Name: "请选择"
        });
      });
    }
  },
  mounted() {
    this.init()
    this.getstatus();
  }
};
</script>
<style>
.elform .el-form-item__content {
  width: 45%;
  margin-left: 0px !important;
}
</style>
<style scoped>
.boxDiv {
  width: 90%;
  margin-left: 5%;
  padding-top: 10px;
  padding-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// extend.vue?598b5780